/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Data_Bad_RequestInputs */



/**
* | output |
* | --- |
* | "The app sent an invalid data request." |
*
* @param {Canvas_Data_Bad_RequestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_data_bad_request = /** @type {((inputs?: Canvas_Data_Bad_RequestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Data_Bad_RequestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die App hat eine ungültige Datenanfrage gesendet.")
	return /** @type {LocalizedString} */ ("The app sent an invalid data request.")
});